import usePayinSessionLazyQuery from 'src/api/graphql/usePayinSessionLazyQuery';
import useSetupSessionLazyQuery from 'src/api/graphql/useSetupSessionLazyQuery';
import {useSessionContext} from 'src/state/usePayinSessionContext';
import {getStore} from 'src/v2/state/store';

export const useResyncSessionState = () => {
  const store = getStore();
  const {clientSecret, sessionId, mode} = useSessionContext();

  const [fetchPayinSession] = usePayinSessionLazyQuery({
    variables: {
      input: {
        crypto_payin_session: sessionId,
        client_secret: clientSecret,
      },
    },
    component: 'useResyncSessionState',
  });

  const [fetchSetupSession] = useSetupSessionLazyQuery({
    variables: {
      input: {
        crypto_setup_session: sessionId,
        client_secret: clientSecret,
      },
    },
    component: 'useResyncSessionState',
  });

  return async () => {
    if (mode === 'pay') {
      const {data} = await fetchPayinSession();
      const state = data?.v1CryptoInternalPayinSession?.state;
      if (state === 'error' || state === 'canceled') {
        store.setValue((s) => {
          s.state = state;
        });
      }
    } else {
      const {data} = await fetchSetupSession();
      const state = data?.v1CryptoInternalSetupSession?.state;
      if (state === 'failed' || state === 'canceled') {
        store.setValue((s) => {
          s.state = state;
        });
      }
    }
  };
};
